export default __webpack_public_path__ + "static/heat_exchanger_w.cc6659957ba220851be892565bf80a15.svg";